import { RelodeApiError, SuccessAction } from "@relode/core";
import {
    ActionsUnion,
    createAction,
    createMetaAction,
} from "@relode/core/components/reducer/actionHelpers";

import { CandidateDetails } from "../../../../shared/types";

enum names {
    HIRE_CANDIDATE_JOB_STATUS_FAILURE = "HIRE_CANDIDATE_JOB_STATUS_FAILURE",
    HIRE_EDIT_FAILURE = "HIRE_EDIT_FAILURE",
    INTERVIEW_ADD_EDIT_FAILURE = "INTERVIEW_ADD_EDIT_FAILURE",
    UPDATE_CANDIDATE_JOB_STATUS = "UPDATE_CANDIDATE_JOB_STATUS",
    UPDATE_CANDIDATE_JOB_STATUS_SUCCESS = "UPDATE_CANDIDATE_JOB_STATUS_SUCCESS",
    UPDATE_CANDIDATE_JOB_STATUS_FAILURE = "UPDATE_CANDIDATE_JOB_STATUS_FAILURE",
}

export default names;

export const creators = {
    hireCandidateFailure: (apiError: RelodeApiError) =>
        createAction(names.HIRE_CANDIDATE_JOB_STATUS_FAILURE, { apiError }),
    hireEditFailure: (apiError: RelodeApiError) =>
        createAction(names.HIRE_EDIT_FAILURE, { apiError }),
    interviewAddEditFailure: () =>
        createAction(names.INTERVIEW_ADD_EDIT_FAILURE),
    updateCandidateJobStatus: () =>
        createAction(names.UPDATE_CANDIDATE_JOB_STATUS),
    updateCandidateJobStatusSuccess: (
        candidate: CandidateDetails,
        message: string
    ) =>
        createMetaAction(
            names.UPDATE_CANDIDATE_JOB_STATUS_SUCCESS,
            new SuccessAction(message),
            { candidate }
        ),
    updateCandidateJobStatusFailure: (apiError: RelodeApiError) =>
        createAction(names.UPDATE_CANDIDATE_JOB_STATUS_FAILURE, { apiError }),
};

export type ChangeStatusActionTypes = ActionsUnion<typeof creators>;
